import { Component, OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-day-view-wrapper',
  templateUrl: './day-view-wrapper.component.html',
  styleUrls: ['./day-view-wrapper.component.css']
})
export class DayViewWrapperComponent implements OnInit, OnDestroy {
  isMobile: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    // Define mobile breakpoint - consider both width and orientation
    // Show mobile view only if:
    // 1. Width is less than 768px AND in portrait orientation
    // 2. Width is less than 568px in any orientation (very small devices)
    const mobilePortraitBreakpoint = '(max-width: 768px) and (orientation: portrait)';
    const verySmallDeviceBreakpoint = '(max-width: 567px)';
    
    // Initial check
    this.isMobile = this.breakpointObserver.isMatched(mobilePortraitBreakpoint) || 
                    this.breakpointObserver.isMatched(verySmallDeviceBreakpoint);
    
    // Watch for breakpoint changes
    this.breakpointObserver
      .observe([mobilePortraitBreakpoint, verySmallDeviceBreakpoint])
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        // Show mobile if either condition is true
        this.isMobile = result.matches;
        LoggerService.log('Screen mode changed - Mobile:', this.isMobile, 'Width:', window.innerWidth, 'Height:', window.innerHeight);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}